import React, { useCallback } from 'react';
import {
  Radio,
  RadioGroupMinimal,
} from '@lifeomic/chroma-react/components/Radio';
import { defineMessages, useIntl } from 'react-intl';

const messages = defineMessages({
  unitPickerLabel: {
    id: 'unitPicker.label',
    defaultMessage: 'Unit picker',
  },
});

type UnitPickerProps = {
  selectedUnit: string;
  units: string[];
  onSelect: (unit: string) => void;
};

export const UnitPicker = ({
  selectedUnit,
  units,
  onSelect,
}: UnitPickerProps) => {
  const { formatMessage } = useIntl();

  const onChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      onSelect(e.target.value as string);
    },
    [onSelect],
  );

  return (
    <RadioGroupMinimal
      value={selectedUnit}
      direction="row"
      onChange={onChange}
      aria-label={formatMessage(messages.unitPickerLabel)}
      fullWidth
    >
      {units.map(unit => (
        <Radio key={unit} label={unit} value={unit} />
      ))}
    </RadioGroupMinimal>
  );
};
